import {
  Card,
  Table,
  Tag,
  Input,
  Button,
  Modal,
  Form,
  Select,
  message,
  Tooltip,
  DatePicker,
  TimePicker,
  Col,
  Row,
  Popover,
  Checkbox,
  Alert,
} from "antd";
import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import TextArea from "antd/lib/input/TextArea";
import { useDispatch } from "react-redux";
import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import Service from "../../service";
import moment from "moment";
import dayjs from 'dayjs';
import { Link, useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { FormOutlined, CloseOutlined, EyeOutlined, DownloadOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import GuidedTour, { hasTourFlag } from "../common/GuidedTour/GuidedTour";
import { capitalizeFirst, YearSelect } from "../../util/YearOptions";
import * as XLSX from "xlsx";
import { getResource } from "../../util/getResourcePermission";
import config from "../../permission/config.json";
import { getRoles } from "../../util/getRoles";
import useBranchList from "../../hooks/useBranchList";
import useReportingManagerList from "../../hooks/useReportingManagerList";
import ResignationFlow from "../AdminSideUserResignation/AdminSideUserResignationFlow";
import ResignationModal from "../Resignation/ResignationFlow";
import { FaEllipsisVertical } from "react-icons/fa6";
import ViewIcon from "../../assets/images/ViewIcon";
import EditIcon from "../../assets/images/EditIcon";
import CloseIcon from "../../assets/images/CloseIcon";
import EmpNameCodeCell from "../common/EmpNameCodeCell";
import NodataFoundIcon from "../../assets/images/NodataFoundIcon";
import ApprovalStatusCell from "../Approvals/ApprovalStatusCell";
import useCompanyDateFormat from "../../hooks/useCompanyDateFormat";
import { TABLE_PAGINATION, DEFAULT_PAGE_SIZE } from "../../constants/tablePagination";
import BulkImportMenu from "../common/BulkImport/BulkImportMenu";

const TOUR_STORAGE_KEY = "tour_seen_manage_resignations";
const TOUR_HINT_STORAGE_KEY = "tour_hint_dismissed_manage_resignations";
// Steps whose target field lives inside the Add Resignation modal - the tour
// opens that real modal itself when it reaches one of these.
const MODAL_STEP_IDS = ["arf-date", "arf-employee", "arf-reason", "arf-comments", "arf-save"];

// Statuses a deep link (?status=) may ask this list for.
const LINK_STATUSES = ["Pending", "Acknowledged", "Accepted"];

function ListingForResignation() {
  const dateFormat = useCompanyDateFormat();
  const dispatch = useDispatch();
  const history = useHistory();
  // Payroll Checklist deep link (?status=Accepted&last_date=missing): accepted
  // resignations that still have no last working date.
  const location = useLocation();
  const checklistNoLastDate = new URLSearchParams(location.search).get("last_date") === "missing";
  const checklistOpenOnly = new URLSearchParams(location.search).get("status") === "Pending,Acknowledged";
  const [form] = Form.useForm();
  const [filterForm] = Form.useForm();
  const companySlug = localStorage.getItem("companyDomain")
  const [cancelResignForm] = Form.useForm();
  const {
    branchList,
  } = useBranchList();
  // Admin-only "Reporting Manager" filter - RM/ARM viewers are already scoped to
  // their own team by the list endpoint, so the filter is not offered to them.
  const { isAdmin, reportingManagerOptions } = useReportingManagerList();
  const branchOptions = branchList.map(branch => ({
    label: branch?.branch_name,
    value: branch?._id,
  }));
  const [isModalOpenCancel, setIsModalOpenCancel] = useState(false);
  const [isModalOpenView, setIsModalOpenView] = useState(false);
  let [filterData, setFilterData] = useState([]);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [cancelstatus, setCancelStatus] = useState("");
  const [seachEnabled, setSearchEnabled] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [Employees, setEmployees] = useState([]);
  const [ename, setName] = useState("");
  const [noticeDate, setNoticeDate] = useState([]);
  const [empId, setEmpId] = useState("");
  const [empIdtoCancel, setEmpIdtoCancel] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [currentRecordStatus, setCurrentRecordStatus] = useState("");
  const [showreasonRevoke, setshowReasonRevoke] = useState("");
  const [showReasonCancel, setshowReasonCancel] = useState("");
  const [attachment, setAttachment] = useState("");
  const [exitFormAttachments, setExitFormAttachments] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [commentsView, setcomments] = useState("");
  const [reasonView, setReason] = useState("");
  const [html, setHtml] = useState([]);
  // Only one row's action popover may be open at a time - same controlled
  // pattern as EmployeeMasterList.
  const [openPopoverId, setOpenPopoverId] = useState(null);
  const Search = Input.Search;
  const searchRef = useRef();
  const [isResignationModalVisible, setIsResignationModalVisible] = useState(false);
  const [isAddResignationModalVisible, setIsAddResignationModalVisible] = useState(false);
  const [isColumnModalVisible, setIsColumnModalVisible] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [isTourHintOpen, setIsTourHintOpen] = useState(false);

  useEffect(() => {
    if (!hasTourFlag(TOUR_STORAGE_KEY) && !hasTourFlag(TOUR_HINT_STORAGE_KEY)) {
      setIsTourHintOpen(true);
    }
  }, []);

  // Once the tour walks past the "Resignation" button, it opens the real Add
  // Resignation modal so the remaining steps can point at its actual fields -
  // and closes it again once the tour leaves those steps.
  const handleTourStepChange = useCallback((step) => {
    setIsAddResignationModalVisible(Boolean(step && MODAL_STEP_IDS.includes(step.id)));
  }, []);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [availableColumns] = useState([
    { key: "EMP_NAME", label: "Employee Name" },
    { key: "DATE_OF_RESIGNATION", label: "Date Of Resignation" },
    { key: "LAST_DATE_NOTICE", label: "Last Date As Per Notice Period" },
    { key: "REQUESTED_LAST_DATE", label: "Requested Last Date" },
    { key: "LAST_DATE", label: "Last Date" },
    { key: "ACCEPTED_DATE", label: "Accepted Date" },
    { key: "REJECTED_DATE", label: "Rejected Date" },
    { key: "CANCELLED_DATE", label: "Cancelled Date" },
    { key: "STATUS", label: "Status" },
    { key: "REASON_RESIGNATION", label: "Reason for resignation" },
    { key: "COMMENTS_RESIGNATION", label: "Comments for resignation" },
    { key: "REASON_REVOKING", label: "Reason for revoking" },
    { key: "REASON_CANCELLING", label: "Reason for Cancelling" },
  ]);

  // Set default selected columns on mount
  useEffect(() => {
    if (selectedColumns.length === 0) {
      setSelectedColumns(availableColumns.map(col => col.key));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formValues = Form.useWatch([], filterForm);

  // 👇 Compute if any field has a value
  const hasAnyValue = formValues
    ? Object.values(formValues).some((v) => v !== undefined && v !== null && v !== "")
    : false;
  const handleOpenResignationModal = () => {
    setIsResignationModalVisible(true);
  };

  const handleCloseResignationModal = () => {
    setIsResignationModalVisible(false);
  };

  const handleOpenAddResignationModal = () => {
    setIsAddResignationModalVisible(true);
  };

  const handleCloseAddResignationModal = () => {
    setIsAddResignationModalVisible(false);
  };

  useEffect(() => {
    getEmployeesResignList();
    getcsvData();
  }, [pagination.current, pagination.pageSize, searchText]);

  // A popover anchored to a row detaches visually once the table scrolls under
  // it, so close it instead of letting it float over unrelated rows.
  useEffect(() => {
    const handleScroll = () => {
      if (openPopoverId !== null) {
        setOpenPopoverId(null);
      }
    };

    window.addEventListener('scroll', handleScroll, true);

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [openPopoverId]);

  /**
   * Run a row action from inside the popover: swallow the click so the table's
   * row handler does not also fire (it opens the Reasons modal), close the
   * popover, then act.
   */
  const handleActionClick = (event, callback) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    setOpenPopoverId(null);
    if (callback) callback();
  };

  const showfilterModal = () => {
    if (filterData && Object.keys(filterData).length > 0) {
      filterForm.setFieldsValue(filterData);
    }
    setIsModalOpenFilter(true);
  };
  const handleCancelFilter = () => {
    // filterForm.resetFields();
    setIsModalOpenFilter(false);
  };
  const onSearch = (value) => {
    setSearchText(value);
    setPagination({ ...pagination, current: 1 });
  };
  const resetSearchFilter = (e) => {
    const keyCode = e && e.keyCode ? e.keyCode : e;
    switch (keyCode) {
      case 8:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      case 46:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      default:
        break;
    }
  };
  const getEmployeesResignList = async (filterData) => {
    try {
      const params = new URLSearchParams(window.location.search);
      let status_filter = params.get("status");
      dispatch(showAuthLoader());
      const reqBody = {
        pageNum: pagination.current,
        pageLimit: pagination.pageSize,
      };
      if (searchText && searchText !== "") {
        reqBody.search = searchText;
        setSearchEnabled(true);
      }

      if (filterData) {
        if (filterData?.month) {
          reqBody.month = filterData.month;
        }
        if (filterData?.year) {
          reqBody.year = filterData.year;
        }
        if (filterData?.branch) {
          reqBody.branch = filterData.branch;
        }
        if (filterData?.resignationStatus) {
          reqBody.resignationStatus = filterData.resignationStatus;
        }
        if (
          filterData?.filter_reporting_manager &&
          filterData.filter_reporting_manager !== "Select"
        ) {
          reqBody.filter_reporting_manager_id =
            filterData.filter_reporting_manager;
        }
      }
      // Link statuses: one status, or a comma list (the Payroll Checklist's
      // "open resignations" link sends "Pending,Acknowledged").
      const linkStatuses = (status_filter || "").split(",").filter(Boolean);
      if (linkStatuses.length && linkStatuses.every((status) => LINK_STATUSES.includes(status))) {
        reqBody.resignationStatus = linkStatuses.join(",");
      }
      if (params.get("last_date") === "missing") {
        reqBody.last_date_missing = true;
      }
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.getresign,
        body: reqBody,
      });

      dispatch(hideAuthLoader());
      if (response?.data?.data?.length > 0) {
        if (filterData?.isActive == true) {
          setPagination({
            ...pagination,
            total: response.data.metaData.totalFilteredCount,
            deactivetotal: response.data.metaData.totaldUsers,
          });
        } else {
          setPagination({
            ...pagination,
            total: response.data.metaData.totalFilteredCount,
          });
        }
        setEmployees(response.data.data);
      } else {
        setPagination({
          ...pagination,
          total: 0,
        });
        setEmployees([]);
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };
  const getcsvData = async (filterData, showLoader = true) => {
    try {
      if (showLoader) {
        dispatch(showAuthLoader());
      }
      const reqBody = {
        isExport: true,
      };

      // Add selected columns
      if (selectedColumns && selectedColumns.length > 0) {
        reqBody.selected_columns = selectedColumns;
      }
      if (searchText && searchText !== "") {
        reqBody.search = searchText;
        setSearchEnabled(true);
      }

      if (filterData) {
        if (filterData?.month) {
          reqBody.month = filterData.month;
        }
        if (filterData?.year) {
          reqBody.year = filterData.year;
        }
        if (filterData?.branch) {
          reqBody.branch = filterData.branch;
        }
        if (filterData?.resignationStatus) {
          reqBody.resignationStatus = filterData.resignationStatus;
        }
        if (
          filterData?.filter_reporting_manager &&
          filterData.filter_reporting_manager !== "Select"
        ) {
          reqBody.filter_reporting_manager_id =
            filterData.filter_reporting_manager;
        }
      }
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.getresign,
        body: reqBody,
      });

      if (showLoader) {
        dispatch(hideAuthLoader());
      }

      if (response?.data?.html) setHtml(response?.data?.html);

    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  const handleMyData = () => {
    history.push(`/${companySlug}/resignation-userlist`);
  };

  // Both separation letters are generated the same way - same request body,
  // same PDF-blob download - so only the endpoint and the file name differ.
  const downloadSeparationLetter = async (record, endpoint, fileName) => {
    try {
      const token = localStorage.getItem("accessToken");
      dispatch(showAuthLoader());

      const requestOptions = {
        method: Service.postMethod,
        body: JSON.stringify({
          employee_id: record?.emp_id,
          last_date: record?.last_date,
        }),
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
      };

      const response = await fetch(Service.API_URL + endpoint, requestOptions);

      // A failed generation comes back as the usual JSON envelope, not a PDF.
      // Without this check the error body gets saved as an unopenable .pdf.
      const contentType = response.headers.get("content-type") || "";
      if (!response.ok || contentType.includes("application/json")) {
        const errorBody = await response.json().catch(() => ({}));
        dispatch(hideAuthLoader());
        message.error(errorBody?.message || "Unable to generate the document");
        return;
      }

      const blob = await response.blob();
      dispatch(hideAuthLoader());

      const fileURL = window.URL.createObjectURL(blob);
      const alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = fileName;
      alink.click();
      // Revoked on the next tick - releasing the blob synchronously after
      // click() cancels the download in some browsers.
      setTimeout(() => window.URL.revokeObjectURL(fileURL), 1000);
    } catch (error) {
      dispatch(hideAuthLoader());
      message.error("Unable to generate the document");
    }
  };

  const exportExperienceLetterPdf = (record) =>
    downloadSeparationLetter(record, Service.experienceLetter, "Experienceletter.pdf");

  const exportRelievingLetterPdf = (record) =>
    downloadSeparationLetter(record, Service.relievingLetter, "Relievingletter.pdf");

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      key: "createdBy",
      render: (text, record) => (
        <>
          <EmpNameCodeCell name={record?.createdBy} code={record?.emp_code} />
          {record?.addedByAdmin && (
            <Tooltip title={record?.addedByName ? `Added by ${capitalizeFirst(record.addedByName)}` : undefined}>
              <Tag color="blue" style={{ marginTop: 4 }}>Added by Admin</Tag>
            </Tooltip>
          )}
        </>
      ),
    },
    {
      title: "Reporting Manager",
      dataIndex: "reporting_mgr",
      key: "reporting_mgr",
      render: (text, record, index) => {
        return <span>{capitalizeFirst(record?.reporting_mgr) || "-"}</span>;
      },
    },
    {
      title: "Date Of Resignation",
      dataIndex: "date_of_resignation",
      key: "date_of_resignation",
      render: (text, record, index) => {
        return (
          <span>{moment(record?.resignation_date).format(dateFormat)}</span>
        );
      },
    },
    {
      title: "Last Date As Per Notice Period",
      dataIndex: "last_date_notice",
      key: "last_date_notice",
      render: (text, record, index) => {
        // The resolved day count sits next to the date it produced, so the
        // number is auditable without opening the policy screen.
        return (
          <span>
            {moment(record?.last_date_notice).format(dateFormat)}
            {record?.notice_period_days != null && (
              <span style={{ color: "#8c8c8c", marginLeft: 6 }}>
                ({record.notice_period_days} days)
              </span>
            )}
          </span>
        );
      },
    },
    {
      title: "Requested Last Date",
      dataIndex: "request_last_date",
      key: "request_last_date",
      render: (text, record, index) => {
        return (
          <span>
            {record?.request_last_date
              ? moment(record?.request_last_date).format(dateFormat)
              : " - "}
          </span>
        );
      },
    },
    {
      title: "Last Date",
      dataIndex: "last_date",
      key: "last_date",
      render: (text, record, index) => {
        if (record?.last_date) {
          return <span>{moment(record?.last_date).format(dateFormat)}</span>;
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "Accepted Date",
      dataIndex: "Accepted Date",
      key: "Accepted Date",
      render: (text, record, index) => {
        const AcceptedRecord = record.statusHistory.find(
          (history) => history.resignationStatus === "Accepted"
        );
        if (AcceptedRecord) {
          return (
            <span>
              {moment(AcceptedRecord.created_At).format(dateFormat)}
            </span>
          );
        } else {
          return <span>-</span>;
        }
      },
    },

    {
      title: "Rejected Date",
      dataIndex: "Rejected Date",
      key: "Rejected Date",
      render: (text, record, index) => {
        const RejectedRecord = record.statusHistory.find(
          (history) => history.resignationStatus === "Rejected"
        );
        if (RejectedRecord) {
          return (
            <span>
              {moment(RejectedRecord.created_At).format(dateFormat)}
            </span>
          );
        } else {
          return <span>-</span>;
        }
      },
    },

    {
      title: "Cancelled Date",
      dataIndex: "Cancelled",
      key: "Cancelled",
      render: (text, record, index) => {
        const cancelledRecord = record.statusHistory.find(
          (history) => history.resignationStatus === "Cancelled"
        );

        if (cancelledRecord) {
          return (
            <span>
              {moment(cancelledRecord.created_At).format(dateFormat)}
            </span>
          );
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record, index) => {
        const status = record?.resignationStatus;
        if (!status) return null;

        const color =
          record?.resignationStatus == "Pending"
            ? "orange"
            : record?.resignationStatus == "Acknowledged"
              ? "blue"
              : record?.resignationStatus == "Accepted"
                ? "green"
                : "red";

        // Same chip, now clickable: RM, HR and Admin all get the per-level
        // breakdown instead of a flat "Pending" that hides which level the
        // resignation is actually sitting at.
        return record?.approval_progress ? (
          <ApprovalStatusCell
            progress={record.approval_progress}
            label={capitalizeFirst(status)}
            color={color}
          />
        ) : (
          <Tag color={color}>{capitalizeFirst(status)}</Tag>
        );
      },
    },
    // {
    //   title: "Actions",
    //   dataIndex: "action",
    //   render: (text, record, index) => {
    //     const actionContent = (
    //       <div style={ { display: "flex", flexDirection: "column" } }>
    //         { getResource(config.RESOURCES.SEPARATION_MANAGEMENT, ["update"]) &&
    //           record?.resignationStatus === "Pending" && (
    //             <Button
    //               type="link"
    //               onClick={ () => showModal(record._id, record?.last_date_notice) }
    //             >
    //               <EditIcon  />
    //               Edit
    //             </Button>
    //           ) }

    //         <Button
    //           type="link"
    //           onClick={ () =>
    //             showModalView(
    //               record._id,
    //               record?.comments,
    //               record?.reason,
    //               record?.reasonRevoke,
    //               record?.reasonCancel
    //             )
    //           }
    //         >
    //           <ViewIcon />
    //           Comments
    //         </Button>

    //         { getRoles(["Admin", "HR"]) && record?.last_date && (
    //           <Button
    //             type="link"
    //             onClick={ () => exportExperienceLetterPdf(record) }
    //           >
    //             <DownloadOutlined  />
    //             Download Documents
    //           </Button>
    //         ) }

    //         { getResource(config.RESOURCES.SEPARATION_MANAGEMENT, ["update"]) &&
    //           record?.resignationStatus !== "Rejected" &&
    //           record?.resignationStatus !== "Cancelled" && (
    //             <Button
    //               type="link"
    //               onClick={ () => {
    //                 showModalCancel(
    //                   record?._id,
    //                   record?.resignationStatus,
    //                   record?.createdBy
    //                 );
    //               } }
    //             >
    //               <CloseOutlined  />
    //               Cancel Resignation
    //             </Button>
    //           ) }
    //       </div>
    //     );

    //     return (
    //       <Popover
    //         content={ actionContent }
    //         trigger="click"
    //         placement="bottom"
    //       >
    //         <Button>
    //           <FaEllipsisVertical />
    //         </Button>
    //       </Popover>
    //     );
    //   },
    // }

    {
      title: "Actions",
      dataIndex: "action",
      className: "actions-column",
      fixed: "right",
      render: (text, record, index) => {
        // Always the same ⋮ popover, whatever the row's status allows - the
        // previous version switched to inline icon buttons whenever a row had
        // two actions or fewer, so the column changed shape from row to row.
        // Collected as data first so a row that allows nothing (a closed
        // Cancelled/Rejected resignation) can skip the trigger entirely rather
        // than opening an empty popover.
        const actions = [];
        // Sub-Admin sees every separation but acts only on its own team
        // (canAct is set for Sub-Admin only).
        const canActOnRow = record?.canAct !== false;

        if (
          canActOnRow &&
          getResource(config.RESOURCES.SEPARATION_MANAGEMENT, ["update"]) &&
          (
            record?.resignationStatus === "Pending" ||
            record?.resignationStatus === "Acknowledged"
          ) &&
          // Admin/HR (and RM/ARM viewing "All") get an unfiltered view -
          // a row can be Pending while sitting at a level this viewer
          // isn't the approver for yet. Trust isPendingForViewer over
          // the flat status when it's present, same as the checkbox
          // screens elsewhere.
          record?.approval_progress?.isPendingForViewer !== false
        ) {
          actions.push({
            key: "takeAction",
            label: "Take Action",
            onClick: () =>
              showModal(record._id, record?.last_date_notice, record?.resignationStatus),
          });
        }

        if (getRoles(["Admin", "HR", "Sub-Admin"]) && record?.last_date) {
          actions.push({
            key: "experienceLetter",
            label: "Download Experience Letter",
            onClick: () => exportExperienceLetterPdf(record),
          });
          actions.push({
            key: "relievingLetter",
            label: "Download Relieving Letter",
            onClick: () => exportRelievingLetterPdf(record),
          });
        }

        if (
          canActOnRow &&
          getResource(config.RESOURCES.SEPARATION_MANAGEMENT, ["update"]) &&
          record?.resignationStatus !== "Rejected" &&
          record?.resignationStatus !== "Cancelled"
        ) {
          actions.push({
            key: "cancel",
            label: "Cancel",
            onClick: () =>
              showModalCancel(
                record?._id,
                record?.resignationStatus,
                record?.createdBy
              ),
          });
        }

        if (actions.length === 0) {
          // Rendered as a Button so the dash inherits the same box as the ⋮
          // trigger on other rows and lines up with it down the column.
          return (
            <Button type="text" disabled style={{ cursor: "default" }}>
              -
            </Button>
          );
        }

        const actionContent = (
          <div className="employee-master-actions">
            <ul>
              {actions.map((action) => (
                <li key={action.key}>
                  <Button
                    type="link"
                    onClick={(event) => handleActionClick(event, action.onClick)}
                  >
                    {action.label}
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        );

        return (
          <Popover
            content={actionContent}
            trigger="click"
            placement="bottom"
            open={openPopoverId === record._id}
            onOpenChange={(visible) => setOpenPopoverId(visible ? record._id : null)}
          >
            <Tooltip title="More Actions" placement="bottom">
              <Button>
                <FaEllipsisVertical />
              </Button>
            </Tooltip>
          </Popover>
        );
      },
    }


  ];

  const handleResetFilter = () => {
    filterForm.resetFields();
    setFilterData([]);
    getEmployeesResignList();
    getcsvData();
  };

  const showModalView = (id, comments, reason, revoke, cancel, attachment, exitFormAttachment) => {
    setIsModalOpenView(true);
    setcomments(comments);
    setReason(reason);
    setshowReasonRevoke(revoke);
    setshowReasonCancel(cancel);
    setAttachment(attachment)
    setExitFormAttachments(Array.isArray(exitFormAttachment) ? exitFormAttachment : []);
  };
  const handleOkView = () => {
    setIsModalOpenView(false);
  };
  const handleCancelView = () => {
    setIsModalOpenView(false);
    setcomments("");
    setReason("");
    setshowReasonRevoke("");
    setshowReasonCancel("");
    setExitFormAttachments([]);
  };
  const showModalCancel = (id, status, name) => {
    cancelResignForm.resetFields();
    setIsModalOpenCancel(true);
    setCancelStatus(status);
    setName(name);
    setEmpIdtoCancel(id);
  };

  const handleCancelforCancel = () => {
    setCancelStatus("");
    setName("");
    setEmpIdtoCancel("");
    setIsModalOpenCancel(false);
    cancelResignForm.resetFields();
  };
  const handleCancelResignation = async (id) => {
    try {
      const reasonCancel = (cancelResignForm.getFieldValue("reasonCancel") || "").trim();
      if (reasonCancel === "") {
        message.error("Reason cannot be empty or just spaces");
      } else {
        let reqBody = {
          resignationStatus: "Cancelled",
          reasonCancel,
        };
        dispatch(showAuthLoader());
        const response = await Service.makeAPICall({
          methodName: Service.putMethod,
          api_url: Service.editresign + "/" + id,
          body: reqBody,
        });
        dispatch(hideAuthLoader());

        if (response.data && response.data.data) {
          message.success(response.data.message);
          setIsModalOpenCancel(false);
          getEmployeesResignList();
          cancelResignForm.resetFields();
        } else {
          message.error(response.data.message);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const showModal = (empId, date, currentStatus) => {
    setIsModalOpen(true);
    setNoticeDate(date);
    setEmpId(empId);
    setCurrentRecordStatus(currentStatus || "");
  };
  /**
   * @param {Object} values - the Resignation Status form values
   */
  const handleOk = async (values) => {
    try {
      let reqBody = {};

      if (values.resignationStatus === "Accepted") {
        reqBody = {
          last_date: moment(values?.date).format("YYYY-MM-DD"),
          resignationStatus: values.resignationStatus,
        };
        if (values.lastWorkingTime) {
          reqBody.last_working_time = moment(values.lastWorkingTime).format("hh:mm A");
        }
      } else {
        reqBody = {
          resignationStatus: values.resignationStatus,
        };
        if (values.resignationStatus === "Rejected") {
          reqBody.reasonRevoke = values.reasonRevoke;
        }
      }

      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: Service.editresign + "/" + empId,
        body: reqBody,
      });
      dispatch(hideAuthLoader());

      const payload = response?.data;

      // Test the status, not the presence of `data` - a refused decision also
      // carries a `data` block (the reason), and truthiness alone reported
      // those as a green success toast while quietly closing the modal as
      // though the decision had gone through.
      if (payload?.status === 200 && payload?.data) {
        message.success(payload.message);
        form.resetFields();
        setIsModalOpen(false);
        setSelectedStatus("");
        setCurrentRecordStatus("");
        getEmployeesResignList();
        return;
      }

      // One line only. Any follow-up guidance stays in `payload.data.hint` for a
      // surface with room for it - a toast is not that surface.
      message.error(payload?.message);
    } catch (error) {
      console.log(error);
    }
  };
  const handleCancel = () => {
    form.resetFields();
    setSelectedStatus("");
    setCurrentRecordStatus("");
    setIsModalOpen(false);
  };
  const handleStatusChange = (value) => {
    setSelectedStatus(value);

  };

  const filterEmp = async (values) => {
    setFilterData(values);
    filterForm.resetFields();
    setIsModalOpenFilter(false);
    getcsvData(values);
    getEmployeesResignList(values);
  };
  const handleTableChange = (page, filters, sorter) => {
    setPagination({ ...pagination, ...page });
  };
  const getFooterDetails = () => {
    return (
      <label>
        Total Records Count is {pagination.total > 0 ? pagination.total : 0}
      </label>
    );
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day') || current.day() === 0 || current.day() === 6;
  };

  const tourSteps = useMemo(() => {
    const steps = [
      {
        id: "mrs-search",
        target: '[data-tour="mrs-search"]',
        title: "Search",
        content: "Search resignations by employee name or code.",
      },
      {
        id: "mrs-filter",
        target: '[data-tour="mrs-filter"]',
        title: "Filter & Export",
        content: "Filter the list by status or date, or export the records to CSV.",
      },
    ];
    if (getResource(config.RESOURCES.SEPARATION, ["create"])) {
      steps.push(
        {
          id: "mrs-add-btn",
          target: '[data-tour="mrs-add-btn"]',
          title: "Add Resignation",
          content: "Raise a resignation on behalf of an employee.",
        },
        {
          id: "arf-date",
          target: '[data-tour="arf-date"]',
          title: "Dates",
          content: "The resignation date is set to today. Pick the requested last working date.",
        },
        {
          id: "arf-employee",
          target: '[data-tour="arf-employee"]',
          title: "Employee",
          content: "Pick the employee - selecting the code fills in the name, and vice versa.",
        },
        {
          id: "arf-reason",
          target: '[data-tour="arf-reason"]',
          title: "Reason",
          content: "Choose the reason for resignation.",
        },
        {
          id: "arf-comments",
          target: '[data-tour="arf-comments"]',
          title: "Comments & Attachments",
          content: "Add a comment, and attach a file if needed.",
        },
        {
          id: "arf-save",
          target: '[data-tour="arf-save"]',
          title: "Save",
          content: "Save once all the details are filled in.",
        },
      );
    }
    steps.push({
      id: "mrs-table",
      target: '[data-tour="mrs-table"]',
      title: "Resignation List",
      content: "Click any row to view or act on that employee's resignation - acknowledge, accept, reject or cancel it.",
    });
    return steps;
  }, []);

  const hintSteps = useMemo(() => [
    {
      target: '[data-tour="mrs-guide-icon"]',
      title: "New here?",
      content: "Click here for a quick guide to this screen.",
      shape: "circle",
    },
  ], []);

  return (
    <div>
      <Modal
        title="Reasons"
        visible={isModalOpenView}
        footer={false}
        onOk={handleOkView}
        onCancel={handleCancelView}
      >
        Reason for resignation : {reasonView === " " ? "-" : reasonView}
        <br />
        <br />
        Comments for resignation : {commentsView === " " ? "-" : commentsView}
        <br />
        <br />
        Reason for revoking :{" "}
        {showreasonRevoke === " " ? "-" : showreasonRevoke}
        <br />
        <br />
        Reason for Cancelling :{" "}
        {showReasonCancel === " " ? "-" : showReasonCancel}
        <br />
        <br />
        Attachment : {" "}
        {attachment && attachment.trim() != "" ? <a
          href={`${Service.Server_Base_URL}/uploads/Feedbacks/${attachment}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {attachment}
        </a> : "-"}
        <br />
        <br />
        Exit Feedback Attachments :{" "}
        {exitFormAttachments.length > 0 ? (
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {exitFormAttachments.map((item) => (
              <li key={item._id || item.filename}>
                <a
                  href={`${Service.Server_Base_URL}/uploads/Feedbacks/${item.filename}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.fieldLabel || item.fieldName}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          "-"
        )}
      </Modal>
      <Modal
        title="Filter"
        width={600}
        visible={isModalOpenFilter}
        footer={[<>
          <Button
            className="ant-delete"
            style={{ marginLeft: "10px" }}
            onClick={() => setIsModalOpenFilter(false)}
          >
            Cancel
          </Button>
          <Button
            className="ant-delete"
            style={{ marginLeft: "10px" }}
            onClick={handleResetFilter}
            disabled={!hasAnyValue}
          >
            Reset
          </Button>
          <Button type="primary" onClick={() => filterForm.submit()}>
            Apply
          </Button>

        </>]}
        onCancel={handleCancelFilter}
      >
        <Form form={filterForm} layout="vertical" className="modal-form-col" onFinish={filterEmp}>
          <Row gutter={[16, 0]} >
            <Col xs={24} md={12} >
              <Form.Item label="Status" name="resignationStatus">
                <Select
                  defaultValue="Select"
                  className="filter-branch"
                  options={[
                    {
                      value: "Pending",
                      label: "Pending",
                    },
                    {
                      value: "Acknowledged",
                      label: "Acknowledged",
                    },
                    {
                      value: "Accepted",
                      label: "Accepted",
                    },
                    {
                      value: "Cancelled",
                      label: "Cancelled",
                    },
                    {
                      value: "Rejected",
                      label: "Rejected",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            {isAdmin && (
              <Col xs={24} md={12}>
                <Form.Item
                  label="Reporting Manager"
                  name="filter_reporting_manager"
                  initialValue="Select"
                >
                  <Select
                    className="filter-branch"
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    options={reportingManagerOptions}
                  />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} md={12} >

              <Form.Item label="Branch" name="branch">
                <Select
                  defaultValue="Select"
                  className="filter-branch"
                  options={branchOptions}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} >

              <Form.Item
                // initialValue={moment().format("MMMM")}
                name="month"
                label="Month"
              >
                <Select
                  defaultValue="Select"
                  options={[
                    {
                      value: "January",
                      label: "January",
                    },
                    {
                      value: "February",
                      label: "February",
                    },
                    {
                      value: "March",
                      label: "March",
                    },
                    {
                      value: "April",
                      label: "April",
                    },
                    {
                      value: "May",
                      label: "May",
                    },
                    {
                      value: "June",
                      label: "June",
                    },
                    {
                      value: "July",
                      label: "July",
                    },
                    {
                      value: "August",
                      label: "August",
                    },
                    {
                      value: "September",
                      label: "September",
                    },
                    {
                      value: "October",
                      label: "October",
                    },
                    {
                      value: "November",
                      label: "November",
                    },
                    {
                      value: "December",
                      label: "December",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} >

              <Form.Item
                className="search-row"
                // initialValue={moment().format("YYYY")}
                label="Year"
                name="year"
              >
                <Select defaultValue="Select" options={YearSelect()} />
              </Form.Item>
            </Col>
          </Row>

        </Form>
      </Modal>
      <Modal
        title="Resignation Status"
        footer={[<>
          <Button

            className='ant-delete delete-btn'
            onClick={() => handleCancelResignation(empIdtoCancel)}
          >
            Cancel Resignation
          </Button>
          <Button
            className='ant-delete delete-btn'
            onClick={handleCancelforCancel}
          >
            Close
          </Button>
        </>]}
        visible={isModalOpenCancel}
        onCancel={handleCancelforCancel}
      >
        <p>
          Resignation status of <strong>{ename}</strong> is {cancelstatus}, if
          you wish to cancel it, click here.
        </p>
        <div style={{ textAlign: "center" }}>
          <Form form={cancelResignForm} layout="vertical">
            <Form.Item
              className="search-row ant-col-xs-24 ant-col-sm-24"
              label="Reason to Cancel"
              name="reasonCancel"
              required
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || !value.trim()) {
                      return Promise.reject(new Error("Please enter a valid reason."));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <TextArea
                style={{ height: 60 }}
                rows={4}
                maxLength={100}
              />
            </Form.Item>

          </Form>
        </div>
      </Modal>
      <Modal
        title="Resignation Status"
        visible={isModalOpen}
        footer={[
          <>
            <Button className='ant-delete' onClick={handleCancel} >
              Cancel
            </Button>
            <Button type="primary" onClick={() => form.submit()} >
              Save
            </Button>

          </>

        ]}
        onCancel={handleCancel}
        width={600}
      >
        <div className="resignation-status-model">
          <Form layout="vertical" onFinish={handleOk} form={form}>
            <Form.Item hidden>{empId}</Form.Item>

            <Form.Item
              className="search-row ant-col-xs-24 ant-col-sm-24"
              label="Resignation Status"
              name="resignationStatus"
              rules={[
                {
                  required: true,
                  message: "Please select Resignation status type!",
                },
              ]}
            >
              <Select
                defaultValue="Select"
                options={[
                  {
                    value: "Acknowledged",
                    label: "Acknowledged",
                  },
                  {
                    value: "Accepted",
                    label: "Accepted",
                  },
                  {
                    value: "Rejected",
                    label: "Rejected",
                  },
                ].filter((option) => currentRecordStatus !== "Acknowledged" || option.value !== "Acknowledged")}
                onChange={handleStatusChange}
              />
            </Form.Item>

            {selectedStatus === "Accepted" && (
              <Form.Item
                initialValue={moment(noticeDate)}
                className="search-row ant-col-xs-24 ant-col-sm-24"
                label="Last Working Date"
                name="date"
                rules={[
                  {
                    required: true,
                    message: "Please select a date!",
                  },
                ]}
              >


                <DatePicker
                  defaultValue={moment(noticeDate)}
                  format="DD-MM-YYYY"
                  disabledDate={disabledDate}
                />
              </Form.Item>
            )}

            {selectedStatus === "Accepted" && (
              <Form.Item
                className="search-row ant-col-xs-24 ant-col-sm-24"
                label="Last Working Time"
                name="lastWorkingTime"
              >
                <TimePicker format="hh:mm A" style={{ width: "100%" }} />
              </Form.Item>
            )}

            {selectedStatus === "Rejected" && (
              <Form.Item
                className="search-row ant-col-xs-24 ant-col-sm-24"
                label="Reason for Rejection"
                name="reasonRevoke"
                rules={[
                  {
                    required: true,
                    message: "Please enter a reason for rejection!",
                  },
                  {
                    validator: (_, value) => {
                      if (!value || !value.trim()) {
                        return Promise.reject(new Error("Reason cannot be empty or just spaces"));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <TextArea rows={4} maxLength={250} />
              </Form.Item>
            )}

          </Form>
        </div>
      </Modal>
      <Card className="employee-card">
        <div className="inout-header text-left">
          <h2>
            Manage Resignations{" "}
            <QuestionCircleOutlined
              data-tour="mrs-guide-icon"
              className="guide-title-icon"
              role="button"
              tabIndex={0}
              onClick={() => setIsTourOpen(true)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") setIsTourOpen(true);
              }}
              title="Click for a step-by-step guide"
            />
          </h2>
          <div className="header-btns">
            {getResource(config.RESOURCES.SEPARATION_MANAGEMENT, ["read"]) ? (
              <>
                {getResource(config.RESOURCES.LAST_WORKING_DAY_LIST, ["read"]) ? (
                  <Link to={`/${companySlug}/last-working-day-emps`}>
                    <Button type="primary">Last working Day List</Button>{" "}
                  </Link>
                ) : (
                  <></>
                )}
                  <Button
                    type="primary"
                    onClick={handleOpenResignationModal}
                  >
                    Apply My Resignation
                  </Button>
                {getResource(config.RESOURCES.SEPARATION, ["create"]) ? (
                  <Button key="mydata" type="primary" onClick={handleMyData}>
                    My Data
                  </Button>
                ) : (<></>
                )}
                <Button data-tour="mrs-add-btn" type="primary" icon={<PlusOutlined />} onClick={handleOpenAddResignationModal}>
                  Resignation
                </Button>

                {getResource(config.RESOURCES.SEPARATION_MANAGEMENT, ["create"]) && (
                  <BulkImportMenu
                    moduleLabel="Separation"
                    endpoints={{
                      upload: Service.separationImportUpload,
                      status: Service.separationImportStatus,
                      history: Service.separationImportHistory,
                      downloadErrors: Service.separationImportDownloadErrors,
                      undo: Service.separationImportUndo,
                      cancel: Service.separationImportCancel,
                      template: Service.separationImportTemplate,
                    }}
                    sampleFileName="separation_import_sample_template.xlsx"
                    onImportComplete={() => getEmployeesResignList(filterData)}
                  />
                )}

                <div hidden>
                  <div dangerouslySetInnerHTML={{ __html: html["html"] }}></div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

        </div>
        <Card className="main-content-wrapper" >

          <div className="search-wrapper" data-tour="mrs-search">
            <Search
              ref={searchRef}
              placeholder="Search..."
              onSearch={onSearch}
              onKeyUp={resetSearchFilter}
              style={{ width: 200 }}
              className="mr2 "
            />
            <div className="filter-btns-wrapper" data-tour="mrs-filter">
              <Button type="primary" className=" filter-btn" onClick={showfilterModal}>
                Filter
              </Button>

              <Button
                onClick={handleResetFilter}
                className="ant-delete"
                disabled={filterData.length != 0 ? false : true}
              >
                Reset
              </Button>
              {getResource(config.RESOURCES.SEPARATION_MANAGEMENT, ["read"]) ? (
                <Button
                  className="btn-secondary "
                  onClick={async () => {
                    setIsColumnModalVisible(true);
                  }}
                >
                  Export CSV
                </Button>
              ) : (
                <></>
              )}


            </div>
          </div>
          {(checklistNoLastDate || checklistOpenOnly) && (
            <Alert
              type="info"
              showIcon
              className="mb-2"
              message={
                checklistNoLastDate
                  ? "Showing only accepted resignations with no last working date (from the Payroll Checklist)."
                  : "Showing only resignations still waiting for a decision - Pending or Acknowledged (from the Payroll Checklist)."
              }
              action={
                <Button
                  size="small"
                  onClick={() => {
                    history.replace(window.location.pathname);
                    getEmployeesResignList(filterData);
                  }}
                >
                  Show all
                </Button>
              }
            />
          )}
          <div className='main-table-wrapper' data-tour="mrs-table">
            <Table
              columns={columns}
              footer={getFooterDetails}
              onChange={handleTableChange}
              dataSource={Employees}
              pagination={{
                ...TABLE_PAGINATION,
                ...pagination,
              }}
              onRow={(record) => {
                return {
                  onClick: (event) => {
                    const isActionColumn = event.target.closest('.ant-table-cell')?.classList.contains('actions-column');
                    if (!isActionColumn) {
                      showModalView(
                        record._id,
                        record?.comments,
                        record?.reason,
                        record?.reasonRevoke,
                        record?.reasonCancel,
                        record?.FeedbackAttachment,
                        record?.exitFeedbackAttachments
                      );
                    }
                  },
                  style: {
                    cursor: 'pointer'
                  }
                };
              }}
              locale={{ emptyText: <NodataFoundIcon /> }}
            />
          </div>
        </Card>
      </Card>

      <ResignationModal
        isVisible={isResignationModalVisible}
        onClose={handleCloseResignationModal}
        onSuccess={getEmployeesResignList}
      />
      <ResignationFlow
        isVisible={isAddResignationModalVisible}
        onClose={handleCloseAddResignationModal}
        onSuccess={getEmployeesResignList}
      />
      {isTourOpen && (
        <GuidedTour steps={tourSteps} onClose={() => setIsTourOpen(false)} storageKey={TOUR_STORAGE_KEY} onStepChange={handleTourStepChange} />
      )}
      {!isTourOpen && isTourHintOpen && (
        <GuidedTour steps={hintSteps} onClose={() => setIsTourHintOpen(false)} storageKey={TOUR_HINT_STORAGE_KEY} />
      )}

      <Modal
        title="Select Columns for Resignation Export"
        open={isColumnModalVisible}
        onCancel={() => setIsColumnModalVisible(false)}
        onOk={async () => {
          if (selectedColumns.length === 0) {
            message.error("Please select at least one column");
            return;
          }
          setIsColumnModalVisible(false);
          dispatch(showAuthLoader());
          await getcsvData(filterData, false);
          dispatch(hideAuthLoader());
          // Wait a bit for HTML to render, then trigger download
          setTimeout(() => {
            const table = document.getElementById("table-to-xls");
            if (table) {
              const wb = XLSX.utils.book_new();
              const ws = XLSX.utils.table_to_sheet(table, { raw: true });
              XLSX.utils.book_append_sheet(wb, ws, "tablexls");
              XLSX.writeFile(wb, "Separation.xlsx");
            }
            getEmployeesResignList(filterData);
          }, 500);
        }}
        okText="Export CSV"
        cancelText="Cancel"
        width={700}
      >
        <div style={{ marginBottom: 16 }}>
          <Checkbox
            checked={
              availableColumns.length > 0 &&
              selectedColumns.length > 0 &&
              selectedColumns.length === availableColumns.length
            }
            indeterminate={
              selectedColumns.length > 0 &&
              selectedColumns.length < availableColumns.length
            }
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedColumns(availableColumns.map((col) => col.key));
              } else {
                setSelectedColumns([]);
              }
            }}
          >
            Select All
          </Checkbox>
        </div>
        <Checkbox.Group
          value={selectedColumns}
          onChange={(values) => setSelectedColumns(values)}
          style={{ width: "100%" }}
        >
          <Row gutter={[16, 8]}>
            {availableColumns.map((column) => (
              <Col xs={12} sm={8} md={6} key={column.key}>
                <Checkbox value={column.key}>{column.label}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Modal>
    </div>
  );
}

export default ListingForResignation;
